import { ContentPage } from "src/components/pages/ContentPage"
import { getStaticProps } from "src/helpers/getStaticProps"

export { getStaticProps }

export default ContentPage
